import { LineUser } from "../domains/LineUser";
import { useQuery } from "react-query";
import { delay } from "../utils/delay";

export function useGetLineUser() {
  return useQuery<LineUser | undefined>(["liff"], async () => {
    if (process.env.REACT_APP_DEBUG_MODE) {
      await delay(1000);
      return mockResponse;
    }
    return await liff
      .init({ liffId: process.env.REACT_APP_LIFF_ID! })
      .then(() => {
        if (!liff.isLoggedIn()) {
          liff.login({
            redirectUri: window.location.href,
          });
        }
      })
      .then(() => Promise.all([liff.getProfile(), liff.getFriendship().catch((e) => ({ friendFlag: false }))]))
      .then(([profile, friendship]) => {
        return {
          display_name: profile.displayName,
          "line-access-token": liff.getAccessToken(),
          "line-user-id": profile.userId,
          friend_flag: friendship.friendFlag,
        };
      })
      .catch(() => {
        return undefined;
      });
  });
}

const mockResponse = {
  display_name: "foobar",
  "line-user-id": "U11eedee1202e5051762b3814c0f4cae8",
  "line-access-token": "eyJhbGciOiJIUzI1NiJ9.ZfsB9GYO65lGmwA5OKH5UEczYGWHyVbF7E5h93G3dXGeeSG8PGmNvt7-1dRlFfHD9kiB6NHbjuRDRlOsm-5_9a0m0T1_8wBayjFZ5KVzWXXVMIkgj7pvu90m7vn0CP485o2n7HPL2mCvxLhTNz4FOtn_sEaTeuaU6wWv1EicyQg.8assWc1U5f9OuvYzs2oRtRS6oCGW9OsVlyDTh6HpXZM",
  friend_flag: true
}
